module.exports = __webpack_public_path__ + "img/propertylist4.7a6ece01.png";